const InviteSvg: React.FC<{ color?: string }> = ({ color }) => {
  return (
    <svg
      width="34"
      height="33"
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.8263 12.4139C21.8263 15.1808 19.5877 17.4239 16.8263 17.4239C14.0649 17.4239 11.8263 15.1808 11.8263 12.4139C11.8263 9.64694 14.0649 7.40388 16.8263 7.40388C19.5877 7.40388 21.8263 9.64694 21.8263 12.4139ZM25.4163 25.4039H26.4163L26.4363 23.2739C26.4363 20.8939 24.8563 18.8939 22.9263 18.8939H10.9263C8.99631 18.8939 7.41631 20.8539 7.41631 23.2739V25.4039H8.41631V23.2739C8.41631 21.4039 9.54631 19.8939 10.9063 19.8939H22.9063C24.2863 19.8939 25.4163 21.4139 25.4163 23.2739V25.4039Z"
        stroke={color || "white"}
      />
      {/* <rect
        x="0.8013"
        y="0.278885"
        width="32.25"
        height="32.25"
        stroke="#8B8B8B"
        stroke-width="0.25"
      /> */}
    </svg>
  );
};

export default InviteSvg;
